// extracted by mini-css-extract-plugin
module.exports = {"items":"index_items_1Dzdz","item":"index_item_3kfTg"};